module.exports = __webpack_public_path__ + "static/media/candy-bubble.6c69d4cf.jpg";